import Head from '../../layouts/Head';
import DiscoverContainer from '../../containers/Discover';
import Footer from '../../layouts/Footer';

const Discover = () => {

  return (
    <>
      <Head Title='Discover' />
      <DiscoverContainer />
      <Footer />
    </>
  );
}

export default Discover;